<dialog-wrapper (onClose)="emitEvent()" (onBackdropClick)="onBackdropClickEvent()" [preventDefault]="hideCloseIcon" [disableBackdropClick]="disableBackdrop" #dialog>
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
    <button *ngIf="!hideCloseIcon" (click)="onCloseDialog()"
      [attr.aria-label]="'Modale.BTN_CHIUDI' | translate"
      role="button">
        <span aria-hidden="true" class="material-symbols-sharp">close</span>
    </button>
  </div>

  <p>
    {{description}}
    @if(showCaptchaTerms){
      <small
        class="d-block recaptcha-terms"
        [innerHTML]="'Captcha.G_DISCLAIMER' | translate"
      >
      </small>
    }
  </p>

  <div class="modal-btn">
    <button *ngIf="!hideCloseButton && !showLoading" (click)="onCloseDialog()" [attr.aria-label]="btnClose | translate" class="modal-btn btn-dismiss">{{btnClose | translate}}</button>
    <button *ngIf="!showLoading"  (click)="onConfirm()" [attr.aria-label]="btnConfirm | translate" class="modal-btn btn-confirm">{{btnConfirm | translate}}</button>
    <button *ngIf="showLoading" [attr.aria-label]="btnLoading | translate" class="modal-btn btn-confirm confirm-loading">{{btnLoading | translate}}</button>
  </div>
</dialog-wrapper>
